import config from 'config'

const PLANS = {
  FULL_SERVICE: config('FULL_SERVICE_CODE'),
  AFFILIATE: config('AFFILIATE_CODE'),
  LITE: config('LITE_CODE'),
  IN_HOUSE_FULL: config('IN_HOUSE_FULL_CODE'),
  IN_HOUSE_RENT: config('IN_HOUSE_RENT_CODE'),
  IN_HOUSE_SELL: config('IN_HOUSE_SELL_CODE'),
  IN_HOUSE_ACQUISITION: config('IN_HOUSE_ACQUISITION_CODE'),
}

const ALL = {
  PLANS
}

const NEXIMO_ADDRESS = 'Av. Insurgentes Sur 1082, Insurgentes San Borja, Benito Juárez, 03100 Ciudad de México, CDMX.'
const NEXIMO_LAT = 19.381390616885923
const NEXIMO_LNG = -99.17670888465702
const NEXIMO_YEAR_CREATION = 2018

const NEXI_CREDITO_URL = 'https://credito.iadmexico.mx'
const HESTIA_URL = 'https://www.hestiaplp.com.mx'
const MY_PROPERTIES_URL = `${config('HOST_URL')}/dashboard/property-management`
const SOGO_EMAIL_URL = 'https://mail.iadmexico.mx/sogo'
// Webmail entry point that starts the SSO (OIDC) login on mailcow instead of asking for a password.
const MAILCOW_SSO_URL = 'https://mail.iadmexico.mx/?iam_sso=1'
// Host used by external mail clients (IMAP/POP3/SMTP/ActiveSync) with an app password.
const MAIL_SERVER_HOST = 'mail.iadmexico.mx'
const HIGH_LEVEL_URL = 'https://crm.iadmexico.mx/login/sso'

export {
  ALL as default,
  PLANS,
  NEXIMO_ADDRESS,
  NEXIMO_LAT,
  NEXIMO_LNG,
  NEXIMO_YEAR_CREATION,
  NEXI_CREDITO_URL,
  HESTIA_URL,
  MY_PROPERTIES_URL,
  SOGO_EMAIL_URL,
  MAILCOW_SSO_URL,
  MAIL_SERVER_HOST,
  HIGH_LEVEL_URL,
}
